import React, { Fragment } from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import Select from "react-select";
import axios from "axios";
import apiUrl from "../../helpers/endpointservice";
import moment from "moment";
import $ from "jquery";
import Pagination from "react-js-pagination";
import {
  UserIcon,
  DivisionCode,
  DivisionCodeActiveIcon,
  Department,
  DepartmentActiveIcon,
  CategoryCode,
  CategoryActiveIcon,
  LevelIcon,
  LevelActiveIcon,
  Designation,
  DesignActiveIcon,
  excel,
  excelImport,
  ManagerDropIcon,
  adduser,
  deleteuser,
  filter,
  SortIcon,
  arrowleft,
  arrowright,
  FailIcon,
  crossWhite,
  crossicon,
  Search,
  EditIconRed,
  RequiredIcon,
  EmailIcon,
  PhoneIcon,
  LastLogin,
  ManagerIcon,
  NotifyIconBlack,
  ApplicationRoleIcon,
  SaveIcon,
  FailedIcon,
  TickIcon,
  reseticon,
  importHead,
  calendardate,
} from "../../custom/ImageImport";
import {
  paginglist,
  paginglistDefault,
  statusList,
  managerLead,
  supervisorLead,
} from "../../custom/CommonJson";
import {
  logoutFunction,
  Loader,
  ToastMessageFailure,
  ToastMessageSuccess,
  DateCustomPicker,
} from "../../custom/CommonFunction";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      isMobile: false,
      isMobile600: false,
      isMobile380: false,
      height: window.innerHeight,
      assigngroups: [],
      applicationRoles: [],
      employeeCode: "",
      show: false,
      isSideView: false,
      isDelete: false,
      isDeleteFail: false,
      isAdd: false,
      isAddHide: false,
      isAddSuccess: false,
      isAddFailure: false,
      isEdit: false,
      isFormValid: true,
      isEditSuccess: false,
      isEditFailure: false,
      isView: false,
      isManage: false,
      isGroup: false,
      isRole: false,
      isManager: false,
      isImport: false,
      isImportFail: false,
      EmailError: false,
      EmailErrorEmpty: false,
      displayNameError: false,
      mainRoleError: false,
      supportRoleError: false,
      isLoadSpinnerTable: true,
      pagedefault: [],
      usersList: [],
      displayname: "",
      email: "",
      sortBy: "displayname",
      sortOrder: "asc",
      pagesize: 10,
      pagenumber: 1,
      deleteList: [],
      deleteAllow: false,
      deleteusersList: [],
      notifyList: [],
      managerList: [],
      managerListDefault: [],
      notifyCheckList: [],
      userId: 0,
      idnumber: 0,
      managerListAll: [],
      managerForFilter: [],
      managerForFilter1: [],
      supervisorListDefault: [],
      userHeading: "",
      ApplicationRole: [],
      LastLogin: "",
      isAddHide: false,
      addeditUser: {
        displayName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        employeeCode: 0,
        previous_EF: 0,
        dateOfJoin: "",
        manager: [],
        supervisor: [],
        notification_types: [],
        status: true,
        actionBy: "admin",
      },
      isLoaderView: false,
      roleArr: [],
      roleobj: "",
      managerList1: [],
      divisionCode: [],
      divisionCodeList: [],
      divisionCodeDefault: [],
      departmentCode: [],
      departmentCodeList: [],
      departmentCodeDefault: [],
      categoryCode: [],
      categoryCodeList: [],
      categoryCodeDefault: [],
      level: [],
      levelList: [],
      levelDefault: [],
      designation: [],
      designationList: [],
      designationDefault: [],
      mainRole: [],
      mainRoleList: [],
      mainRoleDefault: [],
      supportRole: [],
      supportRoleList: [],
      supportRoleDefault: [],
      divisionCodeName: "",
      departmentName: "",
      categoryName: "",
      levelName: "",
      designationName: "",
      managerName: "",
      supervisorName: "",
      mainRoleName: "",
      supportingRoleName: "",
      importUsers: [],
      isImportFailList: [],
      isImportSuccess: false,
      isPhoneError: false,
      EmailErrorExist: false,
      dateOfJoinError: false,
      status: [],
      allowDisable: true,
      managerCheck: true,
      supervisorCheck: true,
      supervisorError: false,
      managerError: false,
      isStatusDisabled: null,
      currentUserId: 0,
      isDuplicateFail: false,
      isFailureMessage: ""
    };
    this.handleManagerAction1 = this.handleManagerAction.bind(this);
    this.handleSupervisorAction1 = this.handleSupervisorAction.bind(this);
    this.handleDivisionCode1 = this.handleDivisionCode.bind(this);
    this.handleDepartmentCode1 = this.handleDepartmentCode.bind(this);
    this.handleCategoryCode1 = this.handleCategoryCode.bind(this);
    this.handleLevel1 = this.handleLevel.bind(this);
    this.handleDesignation1 = this.handleDesignation.bind(this);
    this.handleMainRole1 = this.handleMainRole.bind(this);
    this.handleSupportRole1 = this.handleSupportRole.bind(this);
  }

  componentDidMount() {
    this.setState({
      currentUserId: parseInt(localStorage.getItem("userId"))
    });
    axios
      .get(apiUrl.GetNotify)
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            notifyList: response.data,
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
    this.handleManagerDataUpdate();
    axios
      .get(apiUrl.GetDivisionCode)
      .then((response) => {
        if (response?.status === 200) {
          this.state.divisionCodeList = response?.data?.map((code) => {
            return {
              value: code.id + "," + code.value,
              label: (
                <>
                  <img src={DivisionCodeActiveIcon} />
                  &nbsp;
                  <span>{code.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
    axios
      .get(apiUrl.GetDepartmentCode)
      .then((response) => {
        if (response?.status === 200) {
          this.state.departmentCodeList = response?.data?.map((code) => {
            return {
              value: code.id + "," + code.value,
              label: (
                <>
                  <img src={DepartmentActiveIcon} />
                  &nbsp;
                  <span>{code.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
    axios
      .get(apiUrl.GetCategoryCode)
      .then((response) => {
        if (response?.status === 200) {
          this.state.categoryCodeList = response?.data?.map((code) => {
            return {
              value: code.id + "," + code.value,
              label: (
                <>
                  <img src={CategoryActiveIcon} />
                  &nbsp;
                  <span>{code.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
    axios
      .get(apiUrl.GetLevel)
      .then((response) => {
        if (response?.status === 200) {
          this.state.levelList = response?.data?.map((code) => {
            return {
              value: code.id + "," + code.value,
              label: (
                <>
                  <img src={LevelActiveIcon} />
                  &nbsp;
                  <span>{code.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });

    axios
      .get(apiUrl.GetDesignationName)
      .then((response) => {
        if (response?.status === 200) {
          this.state.designationList = response?.data?.map((code) => {
            return {
              value: code.id + "," + code.value,
              label: (
                <>
                  <img src={DesignActiveIcon} />
                  &nbsp;
                  <span>{code.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });

    axios
      .get(apiUrl.GetMainRole)
      .then((response) => {
        if (response?.status === 200) {
          this.state.mainRoleList = response?.data?.map((code) => {
            return {
              value: code.id + "," + code.value,
              label: (
                <>
                  <img src={DesignActiveIcon} />
                  &nbsp;
                  <span>{code.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });

    axios
      .get(apiUrl.GetSupportingRole)
      .then((response) => {
        if (response?.status === 200) {
          this.state.supportRoleList = response?.data?.map((code) => {
            return {
              value: code.id + "," + code.value,
              label: (
                <>
                  <img src={DesignActiveIcon} />
                  &nbsp;
                  <span>{code.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });

    this.getusers(this.state.pagenumber);
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  componentDidUpdate() { }

  logoutDirect = () => {
    window.location.href = process.env.REACT_APP_LOGOUT;
  };

  getusers = (pagenumber) => {
    let division =
      this.state.divisionCode?.value?.split(",")[0] != undefined
        ? this.state.divisionCode?.value?.split(",")[0]
        : "";
    let department =
      this.state.departmentCode?.value?.split(",")[0] != undefined
        ? this.state.departmentCode?.value?.split(",")[0]
        : "";
    let category =
      this.state.categoryCode?.value?.split(",")[0] != undefined
        ? this.state.categoryCode?.value?.split(",")[0]
        : "";
    let level =
      this.state.level?.value?.split(",")[0] != undefined
        ? this.state.level?.value?.split(",")[0]
        : "";
    let design =
      this.state.designation?.value?.split(",")[0] != undefined
        ? this.state?.designation?.value?.split(",")[0]
        : "";
    let main =
      this.state.mainRole?.value?.split(",")[0] != undefined
        ? this.state.mainRole?.value?.split(",")[0]
        : "";
    let support =
      this.state.supportRole?.value?.split(",")[0] != undefined
        ? this.state?.supportRole?.value?.split(",")[0]
        : "";
    let status =
      this.state.status != "" && this.state.status != null
        ? this.state?.status?.value
        : "";
    axios
      .get(
        apiUrl.GetUsersList +
        "?displayName=" +
        this.state.displayname +
        "&email=" +
        this.state.email +
        "&employeeCode=" +
        this.state.employeeCode +
        "&divsionCodeId=" +
        division +
        "&departmentCodeId=" +
        department +
        "&categoryCodeId=" +
        category +
        "&levelId=" +
        level +
        "&designationId=" +
        design +
        "&mainRoleId=" +
        main +
        "&supportingRoleId=" +
        support +
        "&status=" +
        status +
        "&sortBy=" +
        this.state.sortBy +
        "&sortOrder=" +
        this.state.sortOrder +
        "&pagesize=" +
        this.state.pagesize +
        "&pagenumber=" +
        pagenumber
      )
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            usersList: response.data,
            isLoadSpinnerTable: false,
          });
        }
        this.setState({ isLoadSpinnerTable: false, isLoaderView: false });
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isLoadSpinnerTable: false, isLoaderView: false });
      });
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }

    if (window.innerWidth < 600) {
      this.setState({
        isMobile600: true,
      });
    } else {
      this.setState({
        isMobile600: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.state.isMobile380 = true;
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };

  showFilterSearch = () => {
    this.setState({ isFormValid: true });
    $("#scrollsearch").scrollTop(0);
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("searchScreen")
    );
    myOffcanvas.show();
  };

  showSearchScreen = () => {
    let dataval = this.state.notifyList?.filter(
      (r) =>
        r.name == "notification_type_web" || r.name == "notification_type_email"
    );
    let data = dataval?.map((r) => r.id);
    this.clearData(data);
    this.setState({
      isAddHide: false,
      displayNameError: false,
      EmailError: false,
      dateOfJoinError: false,
      EmailErrorEmpty: false,
      mainRoleError: false,
      supervisorError: false,
      managerError: false,
      supportRoleError: false,
      isAdd: true,
      isEdit: false,
      isView: false,
      isPhoneError: false,
      allowDisable: true,
    });
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    this.handleManagerData();
    $("#sideScreen").removeClass("visible-hide");
  };

  manageLicense = () => {
    this.setState({ isManage: true });
  };

  handlePageChange = (pageNumber) => {
    this.setState({ isLoadSpinnerTable: true, deleteList: [] });
    this.state.pagenumber = pageNumber;
    this.setState({});
    this.getusers(this.state.pagenumber);
  };

  handleManagerDataUpdate = () => {
    axios
      .get(apiUrl.GetUsers)
      .then((response) => {
        if (response?.status === 200) {
          this.state.managerListAll = response.data;
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
  };

  handleManagerData = (id) => {
    this.state.managerForFilter = [];
    this.state.managerListAll.map((r) => {
      if (r.status && r.id != id) {
        this.state.managerForFilter = [...this.state.managerForFilter, r];
      }
    });
    this.state.managerList = this.state.managerForFilter?.map((code) => {
      return {
        value: code.id + "," + code.value,
        label: (
          <>
            <img src={ManagerDropIcon} />
            &nbsp;
            <span>{code.value}</span>
          </>
        ),
      };
    });
    this.state.idnumber = id;
    this.setState({});
  };

  handleAddApplication = () => {
    this.clearData([]);
    this.setState({
      isView: false,
      isEdit: false,
      isAdd: true,
    });
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
  };

  previousPage = () => {
    this.state.pagenumber = this.state.pagenumber - 1;
    this.setState({});
    this.getusers(this.state.pagenumber);
  };

  nextPage = () => {
    this.state.pagenumber = this.state.pagenumber + 1;
    this.setState({});
    this.getusers(this.state.pagenumber);
  };

  sorting = (sortby) => {
    if (sortby == this.state.sortBy) {
      this.state.sortBy = sortby;
      if (this.state.sortOrder == "asc") {
        this.state.sortOrder = "desc";
      } else {
        this.state.sortOrder = "asc";
      }
    } else {
      this.state.sortBy = sortby;
      this.state.sortOrder = "asc";
    }
    this.state.pagenumber = 1;
    this.setState({});
    this.setState({ isLoadSpinnerTable: true });
    this.getusers(this.state.pagenumber);
  };

  pageSize = (e) => {
    this.setState({ isLoadSpinnerTable: true });
    this.state.pagesize = e.value;
    this.state.pagenumber = 1;
    this.setState({});
    this.getusers(this.state.pagenumber);
  };

  handleInputSearch = (e, val) => {
    this.state[val] = e.target.value;
    this.setState({});
  };

  handleFilterSearch = () => {
    const isValid =
      this.state.displayname != "" ||
      this.state.email != "" ||
      this.state.employeeCode ||
      this.state.divisionCode != "" ||
      this.state.departmentCode != "" ||
      this.state.level != "" ||
      this.state.categoryCode != "" ||
      this.state.designation != "" ||
      (this.state.mainRole != "" && this.state.mainRole != null) ||
      (this.state.supportRole != "" && this.state.supportRole != null) ||
      (this.state.status != "" && this.state.status != null);

    if (isValid) {
      this.setState({
        isFormValid: true,
        isLoadSpinnerTable: true,
        pagenumber: 1,
      });
      this.getusers(1);
      document.getElementById("closeSearch").click();
    } else {
      this.setState({ isFormValid: false });
    }
  };

  clearInputFields = () => {
    this.state.displayname = "";
    this.state.email = "";
    this.state.divisionCode = "";
    this.state.departmentCode = "";
    this.state.level = "";
    this.state.categoryCode = "";
    this.state.designation = "";
    this.state.mainRole = "";
    this.state.supportRole = "";
    this.state.status = false;
    this.state.pagenumber = 1;
    this.state.employeeCode = "";
    this.setState({ isLoadSpinnerTable: true });
    this.getusers(1);
  };

  handleFilterClear = (str) => {
    this.state[str] = "";
    this.setState({});
    this.getusers(this.state.pagenumber);
  };

  handleCheckbox = (id) => {
    const { deleteList } = this.state;
    if (deleteList.length == 0) {
      deleteList.push(id);
    } else {
      if (deleteList && deleteList.filter((i) => i == id).length == 1) {
        deleteList.map((i, ind) => (i == id ? deleteList.splice(ind, 1) : ""));
      } else {
        deleteList.push(id);
      }
    }
    this.setState({});
  };

  handleCheckboxTop = () => {
    let data = [];

    if (
      this.state.deleteList?.length != this.state.usersList?.users?.length &&
      this.state.deleteList?.length > 0 &&
      this.state.usersList?.users?.length > 0
    ) {
      this.state.usersList?.users.map((r) => data.push(r.userId));
    }

    if (
      this.state.deleteList?.length == 0 &&
      this.state.usersList?.users?.length > 0
    ) {
      this.state.usersList?.users?.map((r) => data.push(r.userId));
    }

    if (
      this.state.deleteList?.length == this.state.usersList?.users?.length &&
      this.state.usersList?.users?.length > 0
    ) {
      data = [];
    }

    this.state.deleteList = data;
    this.setState({});
  };

  handleCheckboxNotify = (id) => {
    const { notification_types } = this.state.addeditUser;
    if (notification_types?.length == 0) {
      notification_types?.push(id);
    } else {
      if (
        notification_types &&
        notification_types?.filter((i) => i == id).length == 1
      ) {
        notification_types?.map((i, ind) =>
          i == id ? notification_types?.splice(ind, 1) : ""
        );
      } else {
        notification_types?.push(id);
      }
    }
    this.setState({});
  };

  handlePhoneOnchange = () => {
    let phoneType = this.state.notifyList.filter(
      (x) => x.name == "notification_type_sms"
    );
    if (
      phoneType.length > 0 &&
      this.state.addeditUser.notification_types?.indexOf(phoneType[0].id) > -1
    ) {
      this.handleCheckboxNotify(phoneType[0].id);
    }
  };

  handleEditButton = () => {
    this.setState({ isLoaderView: true });
    this.setState({ isEdit: true, isView: false, isAdd: false });
    setTimeout(() => {
      this.setState({ isLoaderView: false });
    }, 500);
  };

  DeleteYes = () => {
    this.setState({ isLoaderView: true });
    axios
      .post(apiUrl.VerifyUser, this.state.deleteList)
      .then((response) => {
        if (response.status == 200) {
          if (response.data.allowDelete == true) {
            let deleteData = "";
            let val = "";

            this.state.deleteList?.map((r, idx) =>
              r != localStorage.getItem("userId")
                ? ((val = "," + r), (deleteData += val))
                : ""
            );

            let datasubstring = deleteData?.substring(1);

            axios
              .delete(apiUrl.ActionUser + "/" + datasubstring + "?userId=" + this.state.currentUserId)
              .then((response) => {
                if (response?.status === 200) {
                  this.getusers(1);
                  this.state.deleteList = [];
                  this.state.pagenumber = 1;
                  this.setState({});
                  this.setState({
                    isDelete: true,
                    isAddSuccess: false,
                    isEditSuccess: false,
                    isImportSuccess: false,
                  });
                  this.handleManagerDataUpdate();
                  setTimeout(() => {
                    this.setState({ isDelete: false });
                  }, 4000);
                } else {
                  this.setState({
                    isDeleteFail: true,
                  });
                  setTimeout(() => {
                    this.setState({ isDeleteFail: false });
                  }, 4000);
                  this.setState({ isLoaderView: false });
                }
              })
              .catch((error) => {
                this.setState({
                  isDeleteFail: true,
                });
                setTimeout(() => {
                  this.setState({ isDeleteFail: false });
                }, 4000);
                logoutFunction(error?.response?.status);
                this.setState({ isLoaderView: false });
              });
          }
          if (response.data.allowDelete == false) {
            this.setState({
              deleteAllow: true,
              deleteusersList: response.data.emails,
            });
            this.setState({ isLoaderView: false });
            document.getElementById("openDeleteUsers")?.click();
          }
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isLoaderView: false });
      });
  };

  handleInputAddEdit = (e, str) => {
    if (str == "dateOfJoin") {
      this.state.addeditUser[str] = e;
    } else {
      if (str == "email") {
        this.state.addeditUser[str] = e.target.value?.toLowerCase();
      } else {
        this.state.addeditUser[str] = e.target.value;
      }
    }
    if (str == "phone" && e.target.value == "") this.handlePhoneOnchange();
    this.setState({});
  };

  handleInputAddEditDate = (e) => {
    let state = { ...this.state };
    state.addeditUser.dateOfJoin = e;
    this.setState(state);
  };

  onWheel = () => {
    this.inputRef.current.blur();
    setTimeout(() => this.inputRef.current.focus(), 10);
  };

  handleKeyDown = (e) => {
    if (e.which === 38 || e.which === 40) {
      e.preventDefault();
    }
  };

  handleEditPage = (id) => {
    this.setState({
      isLoaderView: true,
    });
    let data = [];
    data.push(id);
    axios
      .post(apiUrl.VerifyUser, data)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            allowDisable: response.data.allowDelete,
          });
        }
        this.handleEditPageData(id);
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isLoaderView: false });
      });
  };

  handleEditPageData = (id) => {
    this.handleManagerData(id);
    this.state.idnumber = id;
    this.setState({
      isLoaderView: true,
    });
    this.clearData([]);
    this.setState({
      isView: true,
      isAdd: false,
      isEdit: false,
      userId: id,
      displayNameError: false,
      EmailError: false,
      isPhoneError: false,
      applicationRoles: [],
      roleArr: [],
      ApplicationRole: [],
    });
    this.getviewData(id);
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    $("#sideScreen").removeClass("visible-hide");
  };

  getviewData = (id) => {
    axios
      .get(apiUrl.ActionUser + "/" + id)
      .then((response) => {
        if (response?.status === 200) {
          let notify = Object.keys(response.data?.notificationTypes);
          let notifyArray = [];
          notify &&
            notify.map((r) =>
              this.state.notifyList?.filter((s) => s.value == r)[0]
                ? notifyArray.push(
                  this.state.notifyList?.filter((s) => s.value == r)[0].id
                )
                : ""
            );
          function groupBy(objectArray, property) {
            return objectArray.reduce((acc, obj) => {
              const key = obj[property];
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(obj);
              return acc;
            }, {});
          }
          const groupedPeople = groupBy(
            response.data.application_roles,
            "applicationName"
          );
          Object.values(groupedPeople).forEach((val) =>
            val.map((r) => {
              this.state.applicationRoles.push(r);
            })
          );
          this.state.applicationRoles.map((r) => {
            if (r.assignedRole.length !== 0) {
              this.state.roleArr.push(
                r.applicationName + " - " + r.assignedRole
              );
            }
          });

          this.setState({
            userHeading: response.data.displayName,
            addeditUser: {
              displayName: response.data.displayName,
              firstName: response.data.firstName,
              lastName: response.data.lastName,
              email: response.data.email,
              phone: response.data.phone,
              previous_EF: response.data.previousEF,
              dateOfJoin: response.data.dateOfJoin && response.data.dateOfJoin,
              notification_types: notifyArray,
              employeeCode: response.data?.employeeCode,
              status: response.data?.status,
              manager: this.state.managerList?.filter(
                (r) =>
                  parseInt(r.value?.split(",")[0]) == response.data?.managerId
              )[0],
              supervisor: this.state.managerList?.filter(
                (r) =>
                  parseInt(r.value?.split(",")[0]) ==
                  response.data?.supervisorId
              )[0],
              historyLog: response.data?.historyLog
            },
            LastLogin: response.data.lastlogin && response.data.lastlogin,
            ApplicationRole: this.state.roleArr,
            managerName: response?.data?.managerName,
            supervisorName: response?.data?.supervisorName,
            divisionCodeName: response.data.divisionCode,
            departmentName: response.data.departmentName,
            categoryName: response.data.categoryName,
            levelName: response.data.level,
            designationName: response.data.designationName,
            mainRoleName: response?.data?.mainRoleName,
            supportingRoleName: response?.data?.supportingRoleName,
            supervisorListDefault: this.state.managerList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) == response.data?.supervisorId
            ),
            divisionCodeDefault: this.state.divisionCodeList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.divisionCodeId
            ),
            divisionCode: this.state.divisionCodeList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.divisionCodeId
            )[0],
            departmentCodeDefault: this.state.departmentCodeList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.departmentCodeId
            ),
            departmentCode: this.state.departmentCodeList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.departmentCodeId
            )[0],
            categoryCodeDefault: this.state.categoryCodeList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.categoryCodeId
            ),
            categoryCode: this.state.categoryCodeList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.categoryCodeId
            )[0],
            levelDefault: this.state.levelList?.filter(
              (r) => parseInt(r.value?.split(",")[0]) == response.data?.levelId
            ),
            level: this.state.levelList?.filter(
              (r) => parseInt(r.value?.split(",")[0]) == response.data?.levelId
            )[0],
            designationDefault: this.state.designationList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) == response.data?.designationId
            ),
            designation: this.state.designationList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) == response.data?.designationId
            )[0],
            mainRoleDefault: this.state.mainRoleList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) == response.data?.mainRoleId
            ),
            mainRole: this.state.mainRoleList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) == response.data?.mainRoleId
            )[0],
            supportRoleDefault: this.state.supportRoleList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.supportingRoleId
            ),
            supportRole: this.state.supportRoleList?.filter(
              (r) =>
                parseInt(r.value?.split(",")[0]) ==
                response.data?.supportingRoleId
            )[0]
          });
          this.setState({
            isLoaderView: false,
          });
        } else {
          this.setState({
            isLoaderView: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoaderView: false,
        });
        logoutFunction(error?.response?.status);
      });
  };

  handleAddEdit = () => {
    if (this.state.addeditUser.displayName?.trim() === "") {
      this.state.displayNameError = true;
    }
    if (this.state.addeditUser.displayName?.trim() != "") {
      this.state.displayNameError = false;
    }
    if (this.state.addeditUser.email?.trim() == "") {
      this.state.EmailErrorEmpty = true;
      this.state.EmailError = false;
      this.state.EmailErrorExist = false;
    } else {
      this.state.EmailErrorEmpty = false;
    }

    if (this.state.mainRole?.length == 0 || this.state.mainRole == null) {
      this.state.mainRoleError = true;
    } else {
      this.state.mainRoleError = false;
    }

    if (
      this.state.addeditUser.supervisor == null ||
      this.state.addeditUser.supervisor.length == 0
    ) {
      this.state.supervisorError = true;
    }
    if (
      this.state.addeditUser.supervisor != null &&
      this.state.addeditUser.supervisor.length != 0
    ) {
      this.state.supervisorError = false;
    }

    if (
      this.state.addeditUser.manager == null ||
      this.state.addeditUser.manager?.length == 0
    ) {
      this.state.managerError = true;
    }
    if (
      this.state.addeditUser.manager != null &&
      this.state.addeditUser.manager?.length != 0
    ) {
      this.state.managerError = false;
    }

    if (this.state.supportRole?.length == 0 || this.state.supportRole == null) {
      this.state.supportRoleError = true;
    } else {
      this.state.supportRoleError = false;
    }

    if (
      this.state.addeditUser?.dateOfJoin == "" ||
      this.state.addeditUser?.dateOfJoin == null
    ) {
      this.state.dateOfJoinError = true;
    } else {
      this.state.dateOfJoinError = false;
    }

    let email = this.state.addeditUser.email?.trim();
    let data = this.state.notifyList?.filter(
      (r) => r.name == "notification_type_sms"
    );
    let checkSMS = this.state.addeditUser?.notification_types?.filter(
      (r) => r == data[0]?.id
    );
    if (checkSMS?.length > 0 && this.state.addeditUser.phone == "") {
      this.state.isPhoneError = true;
    }
    if (
      checkSMS?.length == 0 ||
      (checkSMS?.length > 0 && this.state.addeditUser?.phone != "")
    ) {
      this.state.isPhoneError = false;
    }

    this.setState({});

    if (this.state.displayNameError == true) {
      document.getElementById("displayNameId")?.focus();
    } else if (this.state.EmailErrorEmpty == true) {
      document.getElementById("emailId")?.focus();
    } else if (this.state.isPhoneError == true) {
      document.getElementById("phoneId")?.focus();
    } else if (this.state.dateOfJoinError == true) {
      document.getElementById("joinedDateId")?.scrollIntoView();
    } else if (this.state.managerError == true) {
      document.getElementById("managerId")?.scrollIntoView();
    } else if (this.state.supervisorError == true) {
      document.getElementById("supervisorId")?.scrollIntoView();
    }
    else if (this.state.mainRoleError == true) {
      document.getElementById("mainRoleId")?.scrollIntoView();
    } else if (this.state.supportRoleError == true) {
      document.getElementById("supportingRoleId")?.scrollIntoView();
    }

    if (
      this.state.addeditUser.displayName?.trim() != "" &&
      email != "" &&
      this.state.mainRole?.value != undefined &&
      this.state.supportRole?.value != undefined &&
      (checkSMS?.length == 0 ||
        (checkSMS?.length > 0 && this.state.addeditUser?.phone != "")) &&
      this.state.addeditUser?.dateOfJoin != "" &&
      this.state.addeditUser?.dateOfJoin != null &&
      //  this.state.managerCheck == true &&
      //  this.state.supervisorCheck == true &&
      this.state.addeditUser.supervisor != null &&
      this.state.addeditUser.manager != null &&
      this.state.addeditUser.manager?.length != 0 &&
      this.state.addeditUser.supervisor?.length != 0
    ) {
      if (this.state.isAdd == true) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(email).toLowerCase()) == true) {
          this.setState({ isLoaderView: true });
          axios
            .get(apiUrl.VerifyEmail + "?userEmail=" + email)
            .then((response) => {
              if (response?.status === 200) {
                if (response.data == true) {
                  this.addeditdata();
                  this.setState({
                    EmailErrorEmpty: false,
                    EmailError: false,
                    EmailErrorExist: false,
                  });
                } else {
                  this.setState({
                    EmailErrorEmpty: false,
                    EmailErrorExist: true,
                  });
                  document.getElementById("emailId")?.focus();
                  this.setState({ isLoaderView: false });
                }
              } else {
                this.setState({
                  EmailErrorEmpty: false,
                  EmailError: true,
                  isLoaderView: false,
                  EmailErrorExist: false,
                });
              }
            })
            .catch((error) => {
              this.setState({ isLoaderView: false });
              logoutFunction(error?.response?.status);
              this.setState({
                EmailErrorEmpty: false,
                EmailError: true,
                isAdd: false,
              });
              document.getElementById("emailId")?.focus();
            });
        } else {
          this.setState({
            EmailErrorEmpty: false,
            EmailError: true,
          });
          document.getElementById("emailId")?.focus();
        }
      }
    }
    if (
      this.state.addeditUser.displayName?.trim() != "" &&
      this.state.mainRole?.value != undefined &&
      this.state.supportRole?.value != undefined &&
      (checkSMS?.length == 0 ||
        (checkSMS?.length > 0 && this.state.addeditUser?.phone != "")) &&
      this.state.addeditUser?.dateOfJoin != "" &&
      this.state.addeditUser?.dateOfJoin != null &&
      //  this.state.managerCheck == true &&
      // this.state.supervisorCheck == true &&
      this.state.addeditUser.supervisor != null &&
      this.state.addeditUser.manager != null
    ) {
      if (this.state.isEdit == true) {
        this.addeditdata();
      }
    }
  };

  numberInputFormat = (e) => {
    let checkIfNum;
    if (e.key !== undefined) {
      checkIfNum =
        e.key === "e" ||
        e.key === "E" ||
        e.key === "." ||
        e.key === "+" ||
        e.key === "-";
    } else if (e.keyCode !== undefined) {
      checkIfNum =
        e.keyCode === 69 ||
        e.keyCode === 190 ||
        e.keyCode === 187 ||
        e.keyCode === 189;
    }
    return checkIfNum && e.preventDefault();
  };

  handlePaste = (event) => {
    event.preventDefault();
  };

  addeditdata = () => {
    let data = {
      firstName: this.state.addeditUser.firstName?.trim(),
      lastName: this.state.addeditUser.lastName?.trim(),
      displayName: this.state.addeditUser.displayName?.trim(),
      email: this.state.addeditUser.email?.trim(),
      phone: this.state.addeditUser.phone?.trim(),
      previous_EF: this.state.addeditUser.previous_EF
        ? this.state.addeditUser.previous_EF
        : "",
      dateOfJoin:
        this.state.addeditUser.dateOfJoin &&
        moment(this.state.addeditUser.dateOfJoin)?.format("YYYY-MM-DD"),
      manager: [],
      employeeCode: this.state.addeditUser.employeeCode
        ? this.state.addeditUser.employeeCode
        : "",
      notification_types: this.state.addeditUser?.notification_types,
      status: this.state.addeditUser?.status,
      managerId:
        this.state.addeditUser.manager?.value?.split(",")[0] != ""
          ? parseInt(this.state.addeditUser.manager?.value?.split(",")[0])
          : 0,
      supervisorId:
        this.state.addeditUser.supervisor?.value?.split(",")[0] != ""
          ? parseInt(this.state.addeditUser.supervisor?.value?.split(",")[0])
          : 0,
      divisionCodeId:
        this.state.divisionCode?.value?.split(",")[0] != ""
          ? parseInt(this.state.divisionCode?.value?.split(",")[0])
          : 0,
      departmentCodeId:
        this.state.departmentCode?.value?.split(",")[0] != ""
          ? parseInt(this.state.departmentCode?.value?.split(",")[0])
          : 0,
      categoryCodeId:
        this.state.categoryCode?.value?.split(",")[0] != ""
          ? parseInt(this.state.categoryCode?.value?.split(",")[0])
          : 0,
      levelId:
        this.state.level?.value?.split(",")[0] != ""
          ? parseInt(this.state.level?.value?.split(",")[0])
          : 0,
      designationId:
        this.state.designation?.value?.split(",")[0] != ""
          ? parseInt(this.state.designation?.value?.split(",")[0])
          : 0,
      mainRoleId:
        this.state.mainRole?.value?.split(",")[0] != ""
          ? parseInt(this.state.mainRole?.value?.split(",")[0])
          : 0,
      supportingRoleId:
        this.state.supportRole?.value?.split(",")[0] != ""
          ? parseInt(this.state.supportRole?.value?.split(",")[0])
          : 0,
      actionBy: "admin",
      categoryCode: (this.state.categoryCode?.value?.split(",")[1] != null && this.state.categoryCode?.value?.split(",")[1] != undefined && this.state.categoryCode?.value?.split(",")[1] != "")
        ? this.state.categoryCode?.value?.split(",")[1]
        : "",
      departmentCode: (this.state.departmentCode?.value?.split(",")[1] != null && this.state.departmentCode?.value?.split(",")[1] != undefined && this.state.departmentCode?.value?.split(",")[1] != "")
        ? this.state.departmentCode?.value?.split(",")[1]
        : "",
      designation: (this.state.designation?.value?.split(",")[1] != null && this.state.designation?.value?.split(",")[1] != undefined && this.state.designation?.value?.split(",")[1] != "")
        ? this.state.designation?.value?.split(",")[1]
        : "",
      divisionCode: (this.state.divisionCode?.value?.split(",")[1] != null && this.state.divisionCode?.value?.split(",")[1] != undefined && this.state.divisionCode?.value?.split(",")[1] != "")
        ? this.state.divisionCode?.value?.split(",")[1]
        : "",
      level: (this.state.level?.value?.split(",")[1] != null && this.state.level?.value?.split(",")[1] != undefined && this.state.level?.value?.split(",")[1] != "")
        ? this.state.level?.value?.split(",")[1]
        : "",
      mainRole: (this.state.mainRole?.value?.split(",")[1] != null && this.state.mainRole?.value?.split(",")[1] != undefined && this.state.mainRole?.value?.split(",")[1] != "")
        ? this.state.mainRole?.value?.split(",")[1]
        : "",
      managername: (this.state.addeditUser.manager?.value?.split(",")[1] != null && this.state.addeditUser.manager?.value?.split(",")[1] != undefined && this.state.addeditUser.manager?.value?.split(",")[1] != "")
        ? this.state.addeditUser.manager?.value?.split(",")[1]
        : "",
      supervisor: (this.state.addeditUser.supervisor?.value?.split(",")[1] != null && this.state.addeditUser.supervisor?.value?.split(",")[1] != undefined && this.state.addeditUser.supervisor?.value?.split(",")[1] != "")
        ? this.state.addeditUser.supervisor?.value?.split(",")[1]
        : "",
      supportingRole: (this.state.supportRole?.value?.split(",")[1] != null && this.state.supportRole?.value?.split(",")[1] != undefined && this.state.supportRole?.value?.split(",")[1] != "")
        ? this.state.supportRole?.value?.split(",")[1]
        : "",
    };
    if (this.state.isAdd == true) {
      this.postdata(data);
    }
    if (this.state.isAdd == false) {
      this.putdata(data, this.state.userId);
    }
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
  };

  postdata = (data) => {
    this.setState({ isLoaderView: true });
    axios
      .post(apiUrl.ActionUser + "?userId=" + this.state.currentUserId, data)
      .then((response) => {
        this.setState({ isAdd: false });
        if (response?.status === 200) {
          this.state.divisionCode = [];
          this.state.departmentCode = [];
          this.state.categoryCode = [];
          this.state.level = [];
          this.state.designation = [];
          this.state.mainRole = [];
          this.state.supportRole = [];
          this.setState({});
          this.setState({
            isAddSuccess: true,
            isEditSuccess: false,
            isDelete: false,
            isImportSuccess: false,
          });
          this.CancelYes();
          setTimeout(() => {
            this.setState({ isAddSuccess: false });
          }, 4000);
          this.setState({
            addeditUser: {
              displayName: "",
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              manager: [],
              notification_types: [],
              actionBy: "admin",
              employeeCode: "",
            },
            ApplicationRole: [],
            LastLogin: "",
            managerListDefault: [],
          });
          this.getusers(this.state.pagenumber);
          this.handleManagerDataUpdate();
        } else {
          this.setState({ isAddFailure: true });
          setTimeout(() => {
            this.setState({ isAddFailure: false });
          }, 4000);
        }
        setTimeout(() => {
          this.setState({ isLoaderView: false });
        }, 500);
      })
      .catch((error) => {
        document.getElementById("closeModal")?.click();
        if (error.response?.status === 422) {
          this.setState({ isDuplicateFail: true, isFailureMessage: error.response.data?.message ? error.response.data?.message : "User failed to save" });
          setTimeout(() => {
            this.setState({ isDuplicateFail: false, isFailureMessage: "" });
          }, 4000);
        } else {
          this.setState({ isAddFailure: true });
          setTimeout(() => {
            this.setState({ isAddFailure: false });
          }, 4000);
        }
        logoutFunction(error?.response?.status);
        this.setState({ isLoaderView: false });
      });
  };

  putdata = (data, id) => {
    this.setState({ isLoaderView: true });
    axios
      .put(apiUrl.ActionUser + "/" + id + "?userId=" + this.state.currentUserId, data)
      .then((response) => {
        if (response?.status === 200) {
          $("#sideScreen").addClass("visible-hide");
          this.CancelYes();
          this.state.divisionCode = [];
          this.state.departmentCode = [];
          this.state.categoryCode = [];
          this.state.level = [];
          this.state.designation = [];
          this.state.mainRole = [];
          this.state.supportRole = [];
          this.setState({});
          this.getusers(this.state.pagenumber);
          this.handleManagerDataUpdate();
          this.setState({
            addeditUser: {
              displayName: "",
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              manager: [],
              notification_types: [],
              employeeCode: "",
              actionBy: "admin",
            },
            ApplicationRole: [],
            LastLogin: "",
            managerListDefault: [],
          });
          setTimeout(() => {
            this.setState({
              isEditSuccess: true,
              isAddSuccess: false,
              isDelete: false,
              isImportSuccess: false,
            });
          }, 1000);
          setTimeout(() => {
            this.setState({ isEditSuccess: false });
          }, 5000);
        } else {
          this.setState({ isEditFailure: true });
          setTimeout(() => {
            this.setState({ isEditFailure: false });
          }, 4000);
        }
        setTimeout(() => {
          this.setState({ isLoaderView: false });
        }, 4000);
      })
      .catch((error) => {
        if (error.response?.status === 422) {
          this.setState({ isDuplicateFail: true, isFailureMessage: error.response.data?.message ? error.response.data?.message : "User failed to update" });
          setTimeout(() => {
            this.setState({ isDuplicateFail: false, isFailureMessage: "" });
          }, 4000);
        } else {
          this.setState({ isEditFailure: true });
          setTimeout(() => {
            this.setState({ isEditFailure: false });
          }, 4000);
        }
        logoutFunction(error?.response?.status);
        this.setState({ isLoaderView: false });
      });
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(email).toLowerCase()) == true) {
      axios
        .get(apiUrl.VerifyEmail + "?userEmail=" + email)
        .then((response) => {
          if (response?.status === 200) {
            return response.data;
          } else {
            return false;
          }
        })
        .catch((error) => {
          logoutFunction(error?.response?.status);
          return false;
        });
    } else {
      return false;
    }
  };

  handleManagerAction = (e) => {
    if (this.state.isEdit == true) {
      if (e == null) {
        this.verifyLead(managerLead);
      } else {
        this.setState({
          managerCheck: true,
        });
      }
    }
    // if (e == null){
    //   this.setState({
    //     managerError : true
    //   })
    // } else {
    //   this.setState({
    //     managerError: false
    //   })
    // }
    this.state.addeditUser.manager = e;
    this.setState({});
  };

  handleSupervisorAction = (e) => {
    if (this.state.isEdit == true) {
      if (e == null) {
        this.verifyLead(supervisorLead);
      } else {
        this.setState({
          supervisorCheck: true,
        });
      }
    }
    // if (e == null){
    //   this.setState({
    //     supervisorError : true
    //   })
    // } else {
    //   this.setState({
    //     supervisorError: false
    //   })
    // }
    this.state.addeditUser.supervisor = e;
    this.setState({});
  };

  verifyLead = (data) => {
    axios
      .post(
        apiUrl.verifyLeadChange +
        "?id=" +
        this.state.userId +
        "&leadRole=" +
        data
      )
      .then((response) => {
        if (response?.status === 200) {
          if (data == managerLead) {
            this.setState({
              managerCheck: response.data,
            });
          }
          if (data == supervisorLead) {
            this.setState({
              supervisorCheck: response.data,
            });
          }
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
  };

  handleDivisionCode = (e) => {
    this.state.divisionCode = e;
    this.setState({});
  };

  handleDepartmentCode = (e) => {
    this.state.departmentCode = e;
    this.setState({});
  };

  handleCategoryCode = (e) => {
    this.state.categoryCode = e;
    this.setState({});
  };

  handleLevel = (e) => {
    this.state.level = e;
    this.setState({});
  };

  handleDesignation = (e) => {
    this.state.designation = e;
    this.setState({});
  };

  handleMainRole = (e) => {
    this.state.mainRole = e;
    this.setState({});
  };

  handleSupportRole = (e) => {
    this.state.supportRole = e;
    this.setState({});
  };

  cancelToastMessage = () => {
    this.setState({
      isDelete: false,
      isAddSuccess: false,
      isAddFailure: false,
      isEditFailure: false,
      isEditSuccess: false,
      isAddHide: false,
      isImportSuccess: false,
      isDuplicateFail: false,
      isFailureMessage: ""
    });
  };

  clearDataAddEdit = (datavalue) => {
    $("#sideScreen").addClass("visible-hide");
    setTimeout(() => {
      this.clearData(datavalue);
    }, 500);
  };

  clearData = (datavalue) => {
    this.setState({
      addeditUser: {
        displayName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        manager: [],
        supervisor: [],
        notification_types: datavalue,
        previous_EF: null,
        dateOfJoin: "",
        status: true,
        actionBy: "admin",
      },
      ApplicationRole: [],
      LastLogin: "",
      supervisorListDefault: [],
      managerListDefault: [],
      divisionCode: [],
      divisionCodeDefault: [],
      departmentCode: [],
      departmentCodeDefault: [],
      categoryCode: [],
      categoryCodeDefault: [],
      level: [],
      levelDefault: [],
      designation: [],
      designationDefault: [],
      mainRole: [],
      mainRoleDefault: [],
      supportRole: [],
      supportRoleDefault: [],
      isAdd: false,
      isEdit: false,
      isView: false,
      displayNameError: false,
      EmailError: false,
      dateOfJoinError: false,
      EmailErrorEmpty: false,
      mainRoleError: false,
      supervisorError: false,
      managerError: false,
      supportRoleError: false,
      isPhoneError: false,
      managerCheck: true,
      supervisorCheck: true,
      isStatusDisabled: false,
    });
  };

  CancelYes = () => {
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    this.clearDataAddEdit([]);
  };

  handleExport = () => {
    this.setState({ isLoaderView: true });
    let division =
      this.state.divisionCode?.value?.split(",")[0] != undefined
        ? this.state.divisionCode?.value?.split(",")[0]
        : "";
    let department =
      this.state.departmentCode?.value?.split(",")[0] != undefined
        ? this.state.departmentCode?.value?.split(",")[0]
        : "";
    let category =
      this.state.categoryCode?.value?.split(",")[0] != undefined
        ? this.state.categoryCode?.value?.split(",")[0]
        : "";
    let level =
      this.state.level?.value?.split(",")[0] != undefined
        ? this.state.level?.value?.split(",")[0]
        : "";
    let design =
      this.state.designation?.value?.split(",")[0] != undefined
        ? this.state?.designation?.value?.split(",")[0]
        : "";
    axios
      .get(
        apiUrl.ExportUsers +
        "?displayName=" +
        this.state.displayname +
        "&email=" +
        this.state.email +
        "&divsionCodeId=" +
        division +
        "&departmentCodeId=" +
        department +
        "&categoryCodeId=" +
        category +
        "&levelId=" +
        level +
        "&designationId=" +
        design,
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        if (response?.status === 200) {
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          var fileName = "Users.xlsx";
          link.download = fileName;
          link.click();
        }
        this.setState({ isLoaderView: false });
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isLoaderView: false });
      });
  };

  handleImportModalOpen = () => {
    this.setState({
      isImport: true,
      isImportFail: false,
      isImportFailList: [],
      importUsers: [],
    });
  };

  handleInputImportChange = (e) => {
    this.setState({
      importUsers: e.target.files,
    });
  };

  handleRemoveImport = () => {
    this.setState({
      importUsers: [],
    });
  };

  handleImportUsers = (e) => {
    this.setState({ isLoaderView: true });
    let formData = new FormData();
    Array.from(this.state.importUsers).forEach(async (a) => {
      formData.append("file", a);
    });
    axios
      .post(apiUrl.ImportUsers + "?userId=" + this.state.currentUserId, formData)
      .then((response) => {
        if (response.status === 200) {
          this.setState({ isImportSuccess: true });
          setTimeout(() => {
            this.setState({ isImportSuccess: false });
          }, 4000);
          this.getusers(this.state.pagenumber);
          this.handleManagerDataUpdate();
        }
        this.setState({ isLoaderView: false });
        document.getElementById("cancellargeModal")?.click();
      })
      .catch((error) => {
        this.setState({ isLoaderView: false });
        if (error.response.status === 422) {
          this.setState({
            isImportFailList: error.response.data,
            isImportFail: true,
            isImport: false,
          });
        }
        logoutFunction(error?.response?.status);
      });
  };

  handleChangeToggle = (e) => {
    this.state.addeditUser.status = !this.state.addeditUser.status;
    this.setState({});
  };

  handleSearchToggle = (e) => {
    this.state.status = e;
    this.setState({});
  };

  handleBackdrop = () => {
    if (this.state.isAdd || this.state.isView) {
      // this.setState({
      //   isAdd: false,
      //   isEdit: false,
      //   isView: false
      // })
      this.clearDataAddEdit([]);
    }
  };

  disabledStatusToaster = () => {
    this.setState({
      isStatusDisabled: true,
    });
  };

  render() {
    const {
      isMobile,
      isMobile600,
      isMobile380,
      isLoadSpinnerTable,
      sortBy,
      sortOrder,
      usersList,
      pagenumber,
      isAdd,
      isEdit,
      isImportFail,
      isView,
      height,
      deleteList,
      isDelete,
      notifyList,
      addeditUser,
      isAddFailure,
      isAddSuccess,
      isEditFailure,
      isEditSuccess,
      isDeleteFail,
      isImport,
      isImportSuccess,
      isStatusDisabled,
      isDuplicateFail,
      isFailureMessage
    } = this.state;
    let { classes } = this.props;
    return (
      <>
        <Loader loader={this.state.isLoaderView || isLoadSpinnerTable} />
        <div
          className={isMobile ? "" : this.props.sideMenu ? "ml-50" : "ml-250"}
        >
          {isMobile == true ? (
            <div className="row mobile-head w-100 border-bottom margin-left-14px">
              <div className="col-12">
                <label className="text-14-bold">Users</label>
              </div>
            </div>
          ) : (
            <>
              <div className="sub-modules w-100">
                <table width="100%" className="border-bottom">
                  <tbody>
                    <tr>
                      <td>
                        <label className="module-head pl-20 pt-4 pb-4 pr-3">
                          Users
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div
            className={isMobile ? "action-table1 " : "action-table"}
            style={{
              width: isMobile
                ? "100%"
                : this.props.sideMenu
                  ? "calc(100% - 50px)"
                  : "calc(100% - 250px)",
            }}
          >
            <table width="100%">
              <tbody>
                <tr>
                  <td width="90%" className="d-flex align-middle">
                    <div
                      className="d-flex cursor-pointer back-hover pl-10"
                      onClick={this.showSearchScreen}
                    >
                      <img
                        src={adduser}
                        className={`${isMobile380
                          ? "px-1 img-height-45"
                          : "px-2 img-height-50"
                          } py-3`}
                      />
                      <label
                        className={`${isMobile380
                          ? "pt-13 text-12-normal"
                          : "pt-15 text-14-normal "
                          } cursor-pointer pr-10`}
                      >
                        {isMobile600 ? "Add" : "Add user"}
                      </label>
                    </div>
                    <div
                      className={`${deleteList?.length > 0 ? `` : `pointer-none`
                        } d-flex cursor-pointer back-hover`}
                      data-bs-toggle="modal"
                      data-bs-target="#deleteModal"
                    >
                      <img
                        src={deleteuser}
                        className={`${isMobile380
                          ? "px-1 img-height-45"
                          : "px-2 img-height-50"
                          } ${deleteList?.length > 0 ? `` : `opacity02`} py-3`}
                      />
                      <label
                        className={`${isMobile380
                          ? "pt-13 text-12-normal"
                          : "pt-15 text-14-normal"
                          } ${deleteList?.length > 0 ? `` : `color-img`
                          } cursor-pointer pr-10`}
                      >
                        {isMobile600 ? "Delete" : "Delete user"}
                      </label>
                    </div>
                    <div
                      className="d-flex cursor-pointer back-hover"
                      data-bs-toggle="modal"
                      data-bs-target="#largeModal"
                      onClick={() => this.handleImportModalOpen()}
                    >
                      <img
                        src={excelImport}
                        className={`${isMobile380
                          ? "px-1 img-height-45"
                          : "px-2 img-height-50"
                          } py-3`}
                      />
                      <label
                        className={`${isMobile380
                          ? "pt-13 text-12-normal"
                          : "pt-15 text-14-normal "
                          } cursor-pointer pr-10`}
                      >
                        {isMobile600 ? "Import" : "Import users"}
                      </label>
                    </div>
                    <div
                      className="d-flex cursor-pointer back-hover"
                      onClick={() => this.handleExport()}
                    >
                      <img
                        src={excel}
                        className={`${isMobile380
                          ? "px-1 img-height-45"
                          : "px-2 img-height-50"
                          } py-3`}
                      />
                      <label
                        className={`${isMobile380
                          ? "pt-13 text-12-normal"
                          : "pt-15 text-14-normal "
                          } cursor-pointer pr-10`}
                      >
                        {isMobile600 ? "Export" : "Export users"}
                      </label>
                    </div>
                  </td>
                  <td width="10%" className="text-end">
                    <img
                      src={filter}
                      className={`${isMobile380 ? "img-height-45 p-3" : "p-3"
                        } cursor-pointer`}
                      onClick={this.showFilterSearch}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            className={isMobile ? "sub-modules1-table" : "sub-modules-table"}
            style={{
              height: isMobile ? height - 200 : height - 255,
              width: isMobile
                ? "100%"
                : this.props.sideMenu
                  ? "calc(100% - 50px)"
                  : "calc(100% - 250px)",
            }}
          >
            <div className="table-responsive common-table-bottom">
              <table width="100%" id="usersTable" className="pb-2">
                <thead className="border-bottom">
                  <tr>
                    <th
                      className="p-3 border-bottom border-top text-center align-middle"
                      width="3%"
                    >
                      <div
                        className="form-group-check"
                        onClick={() => this.handleCheckboxTop()}
                      >
                        <input
                          type="checkbox"
                          checked={
                            deleteList?.length > 0 &&
                              deleteList?.length == usersList?.users?.length
                              ? true
                              : false
                          }
                        />
                        <label htmlFor="checkbox"></label>
                      </div>
                    </th>
                    <th
                      className="p-3 border-bottom border-top ecode-width"
                      width="29%"
                      onClick={() => this.sorting("employeeCode")}
                    >
                      <label className="text-12-bold cursor-pointer pr-10">
                        Employee code
                      </label>
                      {sortBy == "employeeCode" && sortOrder ? (
                        <img
                          src={SortIcon}
                          className={
                            sortOrder == "asc"
                              ? "cursor-pointer"
                              : "cursor-pointer rotate-180"
                          }
                        />
                      ) : (
                        ""
                      )}
                    </th>
                    <th
                      className="p-3 border-bottom border-top display-width"
                      width="29%"
                      onClick={() => this.sorting("displayname")}
                    >
                      <label className="text-12-bold cursor-pointer pr-10">
                        Display name
                      </label>
                      {sortBy == "displayname" && sortOrder ? (
                        <img
                          src={SortIcon}
                          className={
                            sortOrder == "asc"
                              ? "cursor-pointer"
                              : "cursor-pointer rotate-180"
                          }
                        />
                      ) : (
                        ""
                      )}
                    </th>
                    <th
                      className="p-3 border-top border-bottom"
                      width="30%"
                      onClick={() => this.sorting("email")}
                    >
                      <label className="text-12-bold cursor-pointer pr-10">
                        Email
                      </label>
                      {sortBy == "email" ? (
                        <img
                          src={SortIcon}
                          className={
                            sortOrder == "asc"
                              ? "cursor-pointer "
                              : "cursor-pointer rotate-180"
                          }
                        />
                      ) : (
                        ""
                      )}
                    </th>
                    <th
                      className="p-3 border-top border-bottom login-width"
                      width="38%"
                      onClick={() => this.sorting("lastlogin")}
                    >
                      <label className="text-12-bold cursor-pointer pr-10">
                        Last login
                      </label>
                      {sortBy == "lastlogin" ? (
                        <img
                          src={SortIcon}
                          className={
                            sortOrder == "asc"
                              ? "cursor-pointer "
                              : "cursor-pointer rotate-180"
                          }
                        />
                      ) : (
                        ""
                      )}
                    </th>
                    <th
                      className="p-3 border-top border-bottom login-width"
                      width="38%"
                      onClick={() => this.sorting("status")}
                    >
                      <label className="text-12-bold cursor-pointer pr-10">
                        Status
                      </label>
                      {sortBy == "status" ? (
                        <img
                          src={SortIcon}
                          className={
                            sortOrder == "asc"
                              ? "cursor-pointer "
                              : "cursor-pointer rotate-180"
                          }
                        />
                      ) : (
                        ""
                      )}
                    </th>
                  </tr>
                </thead>
                {isLoadSpinnerTable == false && (
                  <>
                    <tbody>
                      {usersList?.users?.length > 0 ? (
                        usersList?.users?.map((i, idx) => (
                          <>
                            <tr
                              key={idx}
                              style={{
                                backgroundColor:
                                  deleteList?.filter((r) => r == i.userId)
                                    ?.length > 0 &&
                                    i.userId != localStorage.getItem("userId")
                                    ? "#EDEBE9"
                                    : "",
                              }}
                            >
                              <td className="align-middle border-bottom p-3 text-center">
                                {i.userId == localStorage.getItem("userId") ? (
                                  ""
                                ) : (
                                  <div
                                    className="form-group-check"
                                    onClick={() =>
                                      this.handleCheckbox(i.userId)
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={
                                        deleteList?.filter((r) => r == i.userId)
                                          ?.length > 0
                                          ? true
                                          : false
                                      }
                                    />
                                    <label htmlFor="checkbox"></label>
                                  </div>
                                )}
                              </td>
                              <td className="border-bottom p-3">
                                <label className="text-12-normal">
                                  {i.employeeCode}
                                </label>
                              </td>
                              <td className="border-bottom p-3">
                                <label
                                  className="text-12-bold cursor-pointer text-decoration"
                                  onClick={() => this.handleEditPage(i.userId)}
                                >
                                  {i.displayName}
                                </label>
                              </td>
                              <td className="border-bottom p-3">
                                <label className="text-12-normal">
                                  {i.email}
                                </label>
                              </td>
                              <td className="border-bottom p-3">
                                <label className="text-12-normal">
                                  {i.lastlogin &&
                                    moment(i.lastlogin).format(
                                      "DD-MMM-YYYY hh:mm:ss A"
                                    )}
                                </label>
                              </td>
                              <td className="border-bottom p-3">
                                <label className="text-12-normal">
                                  {i.status == true ? "Active" : "Inactive"}
                                </label>
                              </td>
                            </tr>
                          </>
                        ))
                      ) : (
                        <tr>
                          <td className="border-bottom"></td>
                          <td
                            className={`py-2 no-content-message no-wrap border-bottom`}
                            colSpan={5}
                          >
                            No user found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </>
                )}
              </table>
            </div>
          </div>
          <div
            className={`${isMobile
              ? "common-mobilesubmenu mobile-pagination"
              : this.props.sideMenu
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
              } pb-2 pt-2`}
          >
            <table width="100%">
              <tbody>
                <tr>
                  <td width="8%" className="p-3">
                    <div className="select-width">
                      {this.state.usersList?.pagination?.totalcount ? (
                        <Select
                          options={paginglist}
                          defaultValue={paginglistDefault}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.pageSize(e)}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // no box-shadow
                            }),
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td width="92%" className="text-end p-3">
                    {isMobile ? (
                      this.state.usersList?.pagination?.totalcount ? (
                        <Pagination
                          prevPageText={
                            <>
                              <img src={arrowleft} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={arrowright} />
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={(e) => this.handlePageChange(e)}
                          activePage={this.state.pagenumber}
                          totalItemsCount={usersList?.pagination?.totalPages}
                          itemsCountPerPage={
                            this.state.usersList?.pagination?.pageSize
                          }
                        />
                      ) : (
                        ""
                      )
                    ) : this.state.usersList?.pagination?.totalcount ? (
                      <Pagination
                        prevPageText={
                          <>
                            <img src={arrowleft} />
                          </>
                        }
                        nextPageText={
                          <>
                            <img src={arrowright} />
                          </>
                        }
                        linkClassNext="nextArrow"
                        linkClassPrev="prevArrow"
                        itemClass={`page-item`}
                        linkClass="page-link"
                        pageRangeDisplayed={4}
                        onChange={(e) => this.handlePageChange(e)}
                        activePage={this.state.pagenumber}
                        totalItemsCount={
                          this.state.usersList?.pagination?.totalcount
                        }
                        itemsCountPerPage={
                          this.state.usersList?.pagination?.pageSize
                        }
                      />
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ToastMessageFailure
            messageShow={isEditFailure || isAddFailure || isDeleteFail || isDuplicateFail}
            isMobile={isMobile}
            messageText={
              (isAddFailure && "User failed to save") ||
              (isEditFailure && "User failed to update") ||
              (isDeleteFail && "User failed to delete") ||
              (isDuplicateFail && isFailureMessage)
            }
            handleClose={() => this.cancelToastMessage()}
          />

          <ToastMessageSuccess
            messageShow={
              isEditSuccess || isAddSuccess || isDelete || isImportSuccess
            }
            isMobile={isMobile}
            messageText={
              (isEditSuccess && "User updated successfully") ||
              (isAddSuccess && "User saved successfully") ||
              (isDelete && "User deleted successfully") ||
              (isImportSuccess && "User imported successfully")
            }
            handleClose={() => this.cancelToastMessage()}
          />

          {/*Search Screen */}

          <div
            className="offcanvas offcanvas-end offcanvasStyle"
            tabIndex={-1}
            data-bs-scroll="false"
            data-bs-backdrop="true"
            id="searchScreen"
            aria-labelledby="offcanvasScrollingLabel"
          >
            <div className="offcanvas-header pb-3">
              <h6 id="offcanvasRightLabel" className="modal-title text-20-bold">
                Search
              </h6>
              <img
                src={crossicon}
                className={`cursor-pointer text-reset offcavasclose ${isMobile ? "pr-0" : ""
                  }`}
                data-bs-dismiss="offcanvas"
              ></img>
            </div>
            <div
              className="offcanvas-body pl-4 pr-5 scroll-css"
              id="scrollsearch"
            >
              <div className="row">
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 `}
                  >
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={UserIcon} className="contact-icon contact-m7" />{" "}
                      <span className="pl-10 mt-1 text-12-bold">
                        Display name
                      </span>
                      &nbsp;
                    </label>
                    {isMobile && (
                      <div className={`col-12 mt-2 `}>
                        <div>
                          <input
                            className="input-text input-clear text-12-normal w-100"
                            type="text"
                            maxLength={255}
                            autoComplete="off"
                            value={this.state.displayname}
                            onChange={(e) =>
                              this.handleInputSearch(e, "displayname")
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 `}
                  >
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={UserIcon} className="contact-icon contact-m7" />{" "}
                      <span className="pl-10 mt-1 text-12-bold">Email</span>
                      &nbsp;
                    </label>
                    {isMobile && (
                      <div className={`col-12 mt-2 `}>
                        <input
                          className="input-text text-12-normal w-100"
                          type="text"
                          maxLength={255}
                          autoComplete="off"
                          value={this.state.email}
                          onChange={(e) => this.handleInputSearch(e, "email")}
                        />
                      </div>
                    )}
                  </div>
                  {!isMobile && (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 `}
                      >
                        <div>
                          <input
                            className="input-text input-clear text-12-normal w-100"
                            type="text"
                            maxLength={255}
                            autoComplete="off"
                            value={this.state.displayname}
                            onChange={(e) =>
                              this.handleInputSearch(e, "displayname")
                            }
                          />
                        </div>
                      </div>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 `}
                      >
                        <div>
                          <input
                            className="input-text text-12-normal w-100"
                            type="text"
                            maxLength={255}
                            autoComplete="off"
                            value={this.state.email}
                            onChange={(e) => this.handleInputSearch(e, "email")}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={UserIcon} className="contact-icon contact-m7" />{" "}
                      <span className="pl-10 mt-1 text-12-bold">
                        Employee code
                      </span>
                      &nbsp;
                    </label>
                    <div className={`col-12 mt-2`}>
                      <div>
                        <input
                          className={`${isMobile ? "" : "mt-2"
                            } input-text input-clear text-12-normal w-100`}
                          type="number"
                          value={this.state.employeeCode}
                          onChange={(e) =>
                            this.handleInputSearch(e, "employeeCode")
                          }
                          onKeyDown={this.numberInputFormat}
                          onPaste={this.handlePaste}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={DivisionCode} />{" "}
                      <span className="pl-10 text-12-bold">Division code</span>
                      &nbsp;
                    </label>
                  </div>

                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.divisionCode}
                      options={this.state.divisionCodeList}
                      defaultValue={this.state.divisionCodeDefault || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleDivisionCode}
                    />
                  </div>

                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={Department} />{" "}
                      <span className="pl-10 text-12-bold">
                        Department code
                      </span>
                      &nbsp;
                    </label>
                  </div>
                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.departmentCode}
                      options={this.state.departmentCodeList}
                      defaultValue={
                        this.state.departmentCodeDefault || "Select"
                      }
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleDepartmentCode}
                    />
                  </div>

                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={CategoryCode} />{" "}
                      <span className="pl-10 text-12-bold">Category code</span>
                      &nbsp;
                    </label>
                  </div>
                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.categoryCode}
                      options={this.state.categoryCodeList}
                      defaultValue={this.state.categoryCodeDefault || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleCategoryCode}
                    />
                  </div>

                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={LevelIcon} />{" "}
                      <span className="pl-10 text-12-bold">Level</span>
                      &nbsp;
                    </label>
                  </div>
                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.level}
                      options={this.state.levelList}
                      defaultValue={this.state.levelDefault || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleLevel}
                    />
                  </div>

                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={Designation} />{" "}
                      <span className="pl-10 text-12-bold">
                        Designation name
                      </span>
                      &nbsp;
                    </label>
                  </div>
                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.designation}
                      options={this.state.designationList}
                      defaultValue={this.state.designationDefault || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleDesignation}
                    />
                  </div>
                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={Designation} />{" "}
                      <span className="pl-10 text-12-bold">Main role</span>
                      &nbsp;
                    </label>
                  </div>
                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.mainRole}
                      options={this.state.mainRoleList}
                      defaultValue={this.state.mainRoleListDefault || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleMainRole}
                    />
                  </div>

                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={Designation} />{" "}
                      <span className="pl-10 text-12-bold">
                        Supporting role
                      </span>
                      &nbsp;
                    </label>
                  </div>
                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.supportRole}
                      options={this.state.supportRoleList}
                      defaultValue={this.state.supportRoleDefault || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleSupportRole}
                    />
                  </div>

                  <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={UserIcon} className="contact-icon contact-m7" />{" "}
                      <span className="pl-10 mt-1 text-12-bold">
                        Status&nbsp;
                      </span>
                      &nbsp;
                    </label>
                  </div>

                  <div
                    className={
                      isView
                        ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                        : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                    }
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.status}
                      options={statusList}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={this.handleSearchToggle}
                    />
                  </div>

                  <button
                    id="closeSearch"
                    className="offcavasclose d-none"
                    data-bs-dismiss="offcanvas"
                  ></button>
                  {!this.state.isFormValid && (
                    <p className="pt-3 message-search required-color">
                      At least one field is mandatory
                    </p>
                  )}
                  <div
                    className={`${this.state.isFormValid ? "mt-3" : ""
                      } col-12 d-flex`}
                  >
                    <div>
                      <button
                        className="action-button px-3 py-2"
                        onClick={this.handleFilterSearch}
                      >
                        <img src={Search} className="img-top" /> Search
                      </button>
                    </div>
                    <div className="mx-3">
                      <button
                        className="reset-button  px-3"
                        onClick={() => this.clearInputFields()}
                      >
                        <img src={reseticon} className="img-top reset-image" />{" "}
                        Reset
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>

          {/*Add Edit Screen */}

          <div
            className={`viewbar viewbarOpen visible-hide audit-offcanvas ${isMobile && "container"
              }`}
            id="sideScreen"
          >
            <div className={`viewMain ${isMobile && "container"}`}>
              <div className="viewTitle mb-2 ">
                <span className="title">
                  {isAdd && "Add user"}
                  {isEdit && this.state.userHeading}
                  {isView && this.state.addeditUser.displayName}
                </span>
                {isEdit ? (
                  <img
                    src={crossicon}
                    id="closeAddModal"
                    data-bs-toggle="modal"
                    data-bs-target="#cancelModal"
                    className={`cursor-pointer text-reset close ${isMobile ? "pr-0" : ""
                      }`}
                  ></img>
                ) : (
                  <img
                    src={crossicon}
                    className={`cursor-pointer text-reset close ${isMobile ? "pr-0" : ""
                      }`}
                    onClick={() => this.clearDataAddEdit([])}
                  ></img>
                )}
              </div>
              <div>
                {!this.state.isLoaderView && (
                  <div className="row">
                    <>
                      {isView && (
                        <div className={`col-12 mb-2`}>
                          <label
                            className={
                              isMobile
                                ? "d-flex pt-2 m-0 cursor-pointer"
                                : "d-flex m-0 text-left float-start cursor-pointer"
                            }
                            onClick={() => this.handleEditButton()}
                          >
                            <img src={EditIconRed} />{" "}
                            <span className="pl-10 text-12-bold text-decoration pt-4px">
                              Edit
                            </span>
                            &nbsp;
                          </label>
                        </div>
                      )}
                      <div className={isMobile ? "col-12 mt-2" : "col-6 mt-2"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img
                            src={UserIcon}
                            className="contact-icon contact-m7"
                          />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            First name
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isEdit || isAdd ? (
                              <input
                                type="text"
                                maxLength={255}
                                autoComplete="off"
                                className="input-text text-12-normal w-100"
                                value={
                                  this.state.addeditUser.firstName &&
                                  this.state.addeditUser.firstName
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "firstName")
                                }
                              />
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.firstName
                                  ? this.state.addeditUser.firstName
                                  : "-"}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-2"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img
                            src={UserIcon}
                            className="contact-icon contact-m7"
                          />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Last name
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isEdit || isAdd ? (
                              <input
                                type="text"
                                maxLength={255}
                                autoComplete="off"
                                className="input-text text-12-normal w-100"
                                value={
                                  this.state.addeditUser.lastName &&
                                  this.state.addeditUser.lastName
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "lastName")
                                }
                              />
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.lastName
                                  ? this.state.addeditUser.lastName
                                  : "-"}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      {!isMobile && (
                        <>
                          <div className={isView ? `col-6` : `col-6 pt-1`}>
                            {isEdit || isAdd ? (
                              <input
                                type="text"
                                maxLength={255}
                                autoComplete="off"
                                className="input-text text-12-normal w-100"
                                value={
                                  this.state.addeditUser.firstName &&
                                  this.state.addeditUser.firstName
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "firstName")
                                }
                              />
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.firstName
                                  ? this.state.addeditUser.firstName
                                  : "-"}
                              </span>
                            )}
                          </div>
                          <div className={isView ? `col-6` : `col-6 pt-1`}>
                            {isEdit || isAdd ? (
                              <input
                                type="text"
                                maxLength={255}
                                autoComplete="off"
                                className="input-text text-12-normal w-100"
                                value={
                                  this.state.addeditUser.lastName &&
                                  this.state.addeditUser.lastName
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "lastName")
                                }
                              />
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.lastName
                                  ? this.state.addeditUser.lastName
                                  : "-"}
                              </span>
                            )}
                          </div>
                        </>
                      )}

                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img
                            src={UserIcon}
                            className="contact-icon contact-m7"
                          />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Display name&nbsp;
                            {!isView && (
                              <span className="required-color">*</span>
                            )}
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isEdit || isAdd ? (
                              <>
                                <input
                                  type="text"
                                  maxLength={255}
                                  autoComplete="off"
                                  className={`${this.state.displayNameError
                                    ? `border-input`
                                    : ``
                                    } ${`input-text text-12-normal w-100`}`}
                                  value={
                                    this.state.addeditUser.displayName &&
                                    this.state.addeditUser.displayName
                                  }
                                  id="displayNameId"
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "displayName")
                                  }
                                />
                                {this.state.displayNameError && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.displayName
                                  ? this.state.addeditUser.displayName
                                  : "-"}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={EmailIcon} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Email&nbsp;
                            {isAdd && <span className="required-color">*</span>}
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isAdd ? (
                              <>
                                <input
                                  type="text"
                                  maxLength={255}
                                  autoComplete="off"
                                  className={`${this.state.EmailError ||
                                    this.state.EmailErrorEmpty ||
                                    this.state.EmailErrorExist
                                    ? `border-input`
                                    : ``
                                    } ${`input-text text-12-normal w-100`}`}
                                  value={
                                    this.state.addeditUser.email &&
                                    this.state.addeditUser.email
                                  }
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "email")
                                  }
                                  id="emailId"
                                />
                                {this.state.EmailErrorEmpty && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                                {(this.state.EmailError ||
                                  this.state.EmailErrorExist) && (
                                    <>
                                      <div>
                                        <label className="required">
                                          <img src={RequiredIcon} />
                                          &nbsp;
                                          {this.state.addeditUser.email == ""
                                            ? "Required"
                                            : this.state.EmailErrorExist == true
                                              ? "The Email is already existing"
                                              : "Invalid Email"}
                                        </label>
                                      </div>
                                    </>
                                  )}
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.email
                                  ? this.state.addeditUser.email
                                  : "-"}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      {!isMobile && (
                        <>
                          <div
                            className={`${isView
                              ? `col-6`
                              : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 pt-1`
                              } ${isEdit ? "" : ""}
                            `}
                          >
                            {isEdit || isAdd ? (
                              <>
                                <input
                                  type="text"
                                  maxLength={255}
                                  className={`${this.state.displayNameError
                                    ? `border-input`
                                    : ``
                                    } ${`input-text text-12-normal w-100`}`}
                                  value={
                                    this.state.addeditUser.displayName &&
                                    this.state.addeditUser.displayName
                                  }
                                  id="displayNameId"
                                  autoComplete="off"
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "displayName")
                                  }
                                />
                                {this.state.displayNameError && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.displayName
                                  ? this.state.addeditUser.displayName
                                  : "-"}
                              </span>
                            )}
                          </div>
                          <div
                            className={`${isView
                              ? `col-6`
                              : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 pt-1`
                              }
                            `}
                          >
                            {isAdd ? (
                              <>
                                <input
                                  type="text"
                                  maxLength={255}
                                  autoComplete="off"
                                  className={`${this.state.EmailError ||
                                    this.state.EmailErrorEmpty ||
                                    this.state.EmailErrorExist
                                    ? `border-input`
                                    : ``
                                    } ${`input-text text-12-normal w-100`}`}
                                  value={
                                    this.state.addeditUser.email &&
                                    this.state.addeditUser.email
                                  }
                                  id="emailId"
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "email")
                                  }
                                />
                                {this.state.EmailErrorEmpty && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                                {(this.state.EmailError ||
                                  this.state.EmailErrorExist) && (
                                    <>
                                      <div>
                                        <label className="required">
                                          <img src={RequiredIcon} />
                                          &nbsp;
                                          {this.state.addeditUser.email == ""
                                            ? "Required"
                                            : this.state.EmailErrorExist == true
                                              ? "The Email is already existing"
                                              : "Invalid Email"}
                                        </label>
                                      </div>
                                    </>
                                  )}
                              </>
                            ) : (
                              <span
                                className="view-text"
                                title={
                                  this.state.addeditUser.email &&
                                  this.state.addeditUser.email
                                }
                              >
                                {this.state.addeditUser.email
                                  ? this.state.addeditUser.email
                                  : "-"}
                              </span>
                            )}
                          </div>
                        </>
                      )}

                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img
                            src={UserIcon}
                            className="contact-icon contact-m7"
                          />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Employee code
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isEdit || isAdd ? (
                              <input
                                type="number"
                                className="input-text text-12-normal w-100"
                                value={
                                  this.state.addeditUser.employeeCode &&
                                  this.state.addeditUser.employeeCode.trim()
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "employeeCode")
                                }
                                onKeyDown={this.numberInputFormat}
                                onPaste={this.handlePaste}
                              />
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.employeeCode
                                  ? this.state.addeditUser.employeeCode
                                  : "-"}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={PhoneIcon} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Phone&nbsp;
                            {this.state.isPhoneError && (
                              <span className="required-color">*</span>
                            )}
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isEdit || isAdd ? (
                              <input
                                type="number"
                                ref={this.inputRef}
                                onWheel={() => this.onWheel()}
                                className={`${this.state.isPhoneError ? `border-input` : ``
                                  } ${`input-text text-12-normal w-100`}`}
                                onKeyDown={this.handleKeyDown}
                                value={
                                  this.state.addeditUser.phone &&
                                  this.state.addeditUser.phone
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "phone")
                                }
                                id="phoneId"
                              />
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.phone
                                  ? this.state.addeditUser.phone
                                  : "-"}
                              </span>
                            )}
                            {this.state.isPhoneError && (
                              <>
                                <img src={RequiredIcon} />
                                &nbsp;
                                <label className="required">Required</label>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                      {!isMobile && (
                        <>
                          <div
                            className={`${isView
                              ? `col-6`
                              : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 pt-1`
                              }
                            `}
                          >
                            {isEdit || isAdd ? (
                              <input
                                type="number"
                                className="input-text text-12-normal w-100"
                                value={
                                  this.state.addeditUser.employeeCode &&
                                  this.state.addeditUser.employeeCode.trim()
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "employeeCode")
                                }
                                onKeyDown={this.numberInputFormat}
                                onPaste={this.handlePaste}
                              />
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.employeeCode
                                  ? this.state.addeditUser.employeeCode
                                  : "-"}
                              </span>
                            )}
                          </div>
                          <div
                            className={`${isView
                              ? `col-6`
                              : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 pt-1`
                              } ${isEdit ? "" : ""}
                            `}
                          >
                            {isEdit || isAdd ? (
                              <>
                                <input
                                  type="number"
                                  ref={this.inputRef}
                                  onWheel={() => this.onWheel()}
                                  className={`${this.state.isPhoneError
                                    ? `border-input`
                                    : ``
                                    } ${`input-text text-12-normal w-100`}`}
                                  onKeyDown={this.handleKeyDown}
                                  value={
                                    this.state.addeditUser.phone &&
                                    this.state.addeditUser.phone
                                  }
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "phone")
                                  }
                                  id="phoneId"
                                />
                                {this.state.isPhoneError && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.phone
                                  ? this.state.addeditUser.phone
                                  : "-"}
                              </span>
                            )}
                          </div>
                        </>
                      )}

                      <div
                        className={
                          isMobile
                            ? "col-12 mt-4"
                            : isEdit || isAdd
                              ? `col-12 mt-4`
                              : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-4 `
                        }
                      >
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={calendardate} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Joined date
                          </span>
                          &nbsp;
                          {!isView && <span className="required-color">*</span>}
                        </label>
                        {isMobile && (
                          <>
                            <div className={isView ? `col-12` : `col-12 pt-2`}>
                              {isAdd || isEdit ? (
                                <>
                                  <DateCustomPicker
                                    isError={this.state.dateOfJoinError}
                                    value={
                                      this.state.addeditUser.dateOfJoin
                                        ? this.state.addeditUser.dateOfJoin
                                        : null
                                    }
                                    setValue={(e) =>
                                      this.handleInputAddEditDate(e)
                                    }
                                  />
                                </>
                              ) : (
                                <span className="view-text">
                                  {this.state.addeditUser.dateOfJoin
                                    ? moment(
                                      this.state.addeditUser.dateOfJoin
                                    )?.format("DD-MMM-YYYY")
                                    : "-"}
                                </span>
                              )}
                            </div>
                            {this.state.dateOfJoinError && (
                              <>
                                <img src={RequiredIcon} />
                                &nbsp;
                                <label className="required">Required</label>
                              </>
                            )}
                          </>
                        )}
                      </div>
                      {isView && (
                        <div
                          className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-4 `}
                        >
                          <label
                            className={
                              isMobile
                                ? "d-flex pt-2 m-0"
                                : "d-flex m-0 text-left float-start"
                            }
                          >
                            <img src={LastLogin} />{" "}
                            <span className="pl-10 text-12-bold pt-4px">
                              Last login
                            </span>
                            &nbsp;
                          </label>
                          {isMobile && (
                            <div className={isView ? `col-12` : `col-12 pt-1`}>
                              <div
                                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 `}
                              >
                                <label className="view-text">
                                  {this.state.LastLogin
                                    ? moment(this.state.LastLogin).format(
                                      "DD-MMM-YYYY hh:mm:ss A"
                                    )
                                    : "-"}
                                </label>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {!isMobile && (
                        <>
                          <div
                            className={`${isView
                              ? `col-6`
                              : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 pt-2`
                              }
                            `}
                          >
                            {isAdd || isEdit ? (
                              <>
                                <div>
                                  <DateCustomPicker
                                    isError={this.state.dateOfJoinError}
                                    value={
                                      this.state.addeditUser.dateOfJoin
                                        ? this.state.addeditUser.dateOfJoin
                                        : null
                                    }
                                    setValue={(e) =>
                                      this.handleInputAddEditDate(e)
                                    }
                                  />
                                </div>
                                {this.state.dateOfJoinError && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                              </>
                            ) : (
                              <span
                                className="view-text"
                                title={
                                  this.state.addeditUser.dateOfJoin &&
                                  moment(
                                    this.state.addeditUser.dateOfJoin
                                  )?.format("DD-MMM-YYYY")
                                }
                              >
                                {this.state.addeditUser.dateOfJoin
                                  ? moment(
                                    this.state.addeditUser.dateOfJoin
                                  )?.format("DD-MMM-YYYY")
                                  : "-"}
                              </span>
                            )}
                          </div>
                          <div
                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6`}
                          >
                            {isView && (
                              <div
                                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 `}
                              >
                                <label className="view-text">
                                  {this.state.LastLogin
                                    ? moment(this.state.LastLogin).format(
                                      "DD-MMM-YYYY hh:mm:ss A"
                                    )
                                    : "-"}
                                </label>
                              </div>
                            )}
                          </div>{" "}
                        </>
                      )}

                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={ManagerIcon} />{" "}
                          <span id="managerId" className="pl-10 text-12-bold pt-4px">
                            Manager
                          </span>
                          &nbsp;
                          {!isView && <span className="required-color">*</span>}
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <>
                            <div
                              className={
                                this.state.managerError == true && "border-red"
                              }
                            >
                              <Select
                                className="text-12-normal"
                                classNamePrefix="assigngroups"
                                value={this.state.addeditUser.manager}
                                options={this.state.managerList}
                                defaultValue={
                                  this.state.managerListDefault || "Select"
                                }
                                
                                isMulti={false}
                                isSearchable={true}
                                isClearable={true}
                                onChange={this.handleManagerAction}
                              />
                            </div>
                            {this.state.managerError == true && (
                              <>
                                <img src={RequiredIcon} />
                                &nbsp;
                                <label className="required">Required</label>
                              </>
                            )}
                          </>
                        ) : (
                          <div className="view-text">
                            {this.state.managerName}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={ManagerIcon} />{" "}
                          <span id="supervisorId" className="pl-10 text-12-bold pt-4px">
                            Supervisor
                          </span>
                          &nbsp;
                          {!isView && <span className="required-color">*</span>}
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <>
                            <div
                              className={
                                this.state.supervisorError == true &&
                                "border-red"
                              }
                            >
                              <Select
                                className="text-12-normal"
                                classNamePrefix="assigngroups"
                                value={this.state.addeditUser.supervisor}
                                options={this.state.managerList}
                                defaultValue={
                                  this.state.supervisorListDefault || "Select"
                                }
                                isMulti={false}
                                isSearchable={true}
                                isClearable={true}
                                onChange={this.handleSupervisorAction}
                              />
                            </div>
                            {this.state.supervisorError == true && (
                              <>
                                <img src={RequiredIcon} />
                                &nbsp;
                                <label className="required">Required</label>
                              </>
                            )}
                          </>
                        ) : (
                          <div className="view-text">
                            {this.state.supervisorName}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={NotifyIconBlack} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Notification types
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <>
                            {notifyList &&
                              notifyList.map((i, idx) => (
                                <>
                                  <div className="pb-10">
                                    <div
                                      className="form-group-check"
                                      id={
                                        i?.name == "notification_type_web" ||
                                          (i?.name == "notification_type_sms" &&
                                            !this.state?.addeditUser?.phone)
                                          ? "Notifylabel"
                                          : "form-group-check-notify"
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={
                                          addeditUser.notification_types?.filter(
                                            (r) => r == i.id
                                          )?.length > 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          this.handleCheckboxNotify(i.id)
                                        }
                                        className={
                                          i?.name == "notification_type_web" ||
                                            (i?.name == "notification_type_sms" &&
                                              !this.state?.addeditUser?.phone)
                                            ? "pointer-none"
                                            : ""
                                        }
                                      />
                                      <label
                                        htmlFor="checkbox"
                                        onClick={() =>
                                          this.handleCheckboxNotify(i.id)
                                        }
                                        className={
                                          i?.name == "notification_type_web" ||
                                            (i?.name == "notification_type_sms" &&
                                              !this.state?.addeditUser?.phone)
                                            ? "pointer-none"
                                            : ""
                                        }
                                      >
                                        {"    " + i.value + " Notification"}
                                      </label>
                                    </div>
                                  </div>
                                </>
                              ))}
                          </>
                        ) : (
                          <>
                            {notifyList &&
                              notifyList.map((i, idx) =>
                                addeditUser.notification_types?.filter(
                                  (r) => r == i.id
                                )?.length > 0 ? (
                                  <div className="view-text">
                                    {i.value + " Notification"}
                                  </div>
                                ) : (
                                  ""
                                )
                              )}
                          </>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={DivisionCode} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Division code
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <Select
                            className="text-12-normal"
                            classNamePrefix="assigngroups"
                            value={this.state.divisionCode}
                            options={this.state.divisionCodeList}
                            defaultValue={
                              this.state.divisionCodeDefault || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={this.handleDivisionCode}
                          />
                        ) : (
                          <div className="view-text">
                            {this.state.divisionCodeName
                              ? this.state.divisionCodeName
                              : "-"}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={Department} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Department code
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <Select
                            className="text-12-normal"
                            classNamePrefix="assigngroups"
                            value={this.state.departmentCode}
                            options={this.state.departmentCodeList}
                            defaultValue={
                              this.state.departmentCodeDefault || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={this.handleDepartmentCode}
                          />
                        ) : (
                          <div className="view-text">
                            {this.state.departmentName
                              ? this.state.departmentName
                              : "-"}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={CategoryCode} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Category code
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <Select
                            className="text-12-normal"
                            classNamePrefix="assigngroups"
                            value={this.state.categoryCode}
                            options={this.state.categoryCodeList}
                            defaultValue={
                              this.state.categoryCodeDefault || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={this.handleCategoryCode}
                          />
                        ) : (
                          <div className="view-text">
                            {this.state.categoryName
                              ? this.state.categoryName
                              : "-"}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={LevelIcon} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Level
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <Select
                            className="text-12-normal"
                            classNamePrefix="assigngroups"
                            value={this.state.level}
                            options={this.state.levelList}
                            defaultValue={this.state.levelDefault || "Select"}
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={this.handleLevel}
                          />
                        ) : (
                          <div className="view-text">
                            {this.state.levelName ? this.state.levelName : "-"}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={Designation} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Designation name
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <Select
                            className="text-12-normal"
                            classNamePrefix="assigngroups"
                            value={this.state.designation}
                            options={this.state.designationList}
                            defaultValue={
                              this.state.designationDefault || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={this.handleDesignation}
                          />
                        ) : (
                          <div className="view-text">
                            {this.state.designationName
                              ? this.state.designationName
                              : "-"}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={Designation} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Main role&nbsp;
                            {!isView && (
                              <span className="required-color">*</span>
                            )}
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <>
                            <div
                              className={
                                this.state.mainRoleError && "border-red"
                              }
                            >
                              <Select
                                className="text-12-normal"
                                classNamePrefix="assigngroups"
                                value={this.state.mainRole}
                                options={this.state.mainRoleList}
                                defaultValue={
                                  this.state.mainRoleDefault || "Select"
                                }
                                isMulti={false}
                                isSearchable={true}
                                isClearable={true}
                                onChange={this.handleMainRole}
                                id="mainRoleId"
                              />
                            </div>
                            {this.state.mainRoleError && (
                              <>
                                <img src={RequiredIcon} />
                                &nbsp;
                                <label className="required">Required</label>
                              </>
                            )}
                          </>
                        ) : (
                          <div className="view-text">
                            {this.state?.mainRoleName}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={Designation} />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Supporting role&nbsp;
                            {!isView && (
                              <span className="required-color">*</span>
                            )}
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1`
                        }
                      >
                        {isEdit || isAdd ? (
                          <>
                            <div
                              className={
                                this.state.supportRoleError && "border-red"
                              }
                            >
                              <Select
                                className="text-12-normal"
                                classNamePrefix="assigngroups"
                                value={this.state.supportRole}
                                options={this.state.supportRoleList}
                                defaultValue={
                                  this.state.supportRoleDefault || "Select"
                                }
                                isMulti={false}
                                isSearchable={true}
                                isClearable={true}
                                onChange={this.handleSupportRole}
                                id="supportingRoleId"
                              />
                            </div>
                            {this.state.supportRoleError && (
                              <>
                                <img src={RequiredIcon} />
                                &nbsp;
                                <label className="required">Required</label>
                              </>
                            )}
                          </>
                        ) : (
                          <div className="view-text">
                            {this.state?.supportingRoleName}
                          </div>
                        )}
                      </div>

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img
                            src={UserIcon}
                            className="contact-icon contact-m7"
                          />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Previous EF&nbsp;
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isEdit || isAdd ? (
                              <>
                                <input
                                  type="number"
                                  className="input-text text-12-normal w-100"
                                  value={
                                    this.state.addeditUser.previous_EF &&
                                    this.state.addeditUser.previous_EF
                                  }
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "previous_EF")
                                  }
                                />
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.previous_EF
                                  ? this.state.addeditUser.previous_EF
                                  : "-"}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      {!isMobile && (
                        <>
                          <div
                            className={`${isView
                              ? `col-6`
                              : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 pt-1`
                              } ${isEdit ? "" : ""}
                            `}
                          >
                            {isEdit || isAdd ? (
                              <>
                                <input
                                  type="number"
                                  className={`${this.state.previous_EF ? `border-input` : ``
                                    } ${`input-text text-12-normal w-100`}`}
                                  value={
                                    this.state.addeditUser.previous_EF &&
                                    this.state.addeditUser.previous_EF
                                  }
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "previous_EF")
                                  }
                                />
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditUser.previous_EF
                                  ? this.state.addeditUser.previous_EF
                                  : "-"}
                              </span>
                            )}
                          </div>
                        </>
                      )}

                      <div className={isMobile ? "col-12 mt-4" : "col-12 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img
                            src={UserIcon}
                            className="contact-icon contact-m7"
                          />{" "}
                          <span className="pl-10 text-12-bold pt-4px">
                            Status&nbsp;
                          </span>
                          &nbsp;
                        </label>
                      </div>

                      <div
                        className={
                          isView
                            ? `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`
                            : `col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-1 d-flex`
                        }
                      >
                        {isView == false ? (
                          <>
                            <div
                              className="d-flex"
                              onClick={() =>
                                !this.state.allowDisable &&
                                this.disabledStatusToaster()
                              }
                            >
                              <div
                                className={` ${this.state.allowDisable == false
                                  ? "pointer-none"
                                  : "cursor-pointer"
                                  } ${"form-check form-switch"}`}
                              >
                                <input
                                  className={` ${this.state.allowDisable == false
                                    ? "pointer-none"
                                    : "cursor-pointer"
                                    }  ${"form-check-input toggle-button"}`}
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  onChange={(e) => this.handleChangeToggle(e)}
                                  checked={this.state.addeditUser?.status}
                                />
                              </div>
                              <label
                                className={` ${this.state.allowDisable == false
                                  ? ""
                                  : "cursor-pointer"
                                  } ${isView ? `` : `mt-1 pl-10`} view-text`}
                                for={
                                  this.state.allowDisable == false
                                    ? ""
                                    : "flexSwitchCheckChecked"
                                }
                              >
                                {this.state.addeditUser?.status == true
                                  ? "Active"
                                  : "Inactive"}
                              </label>
                            </div>
                          </>
                        ) : (
                          <div className="view-text">
                            {this.state.addeditUser?.status == true
                              ? "Active"
                              : "Inactive"}
                          </div>
                        )}
                      </div>
                      {this.state.allowDisable == false &&
                        this.state.isStatusDisabled == true &&
                        isView == false && (
                          <div className="mt-2 message-search required-color">
                            This user is assigned as Supervisor/Manager. So
                            can't change the status.
                          </div>
                        )}
                      {isView && (
                        <>
                          <div className={`col-12 mt-4 `}>
                            <label
                              className={
                                isMobile
                                  ? "d-flex pt-2 m-0"
                                  : "d-flex m-0 text-left float-start"
                              }
                            >
                              <img src={ApplicationRoleIcon} />{" "}
                              <span className="pl-10 text-12-bold pt-4px">
                                Applications - Roles
                              </span>
                              &nbsp;
                            </label>
                          </div>
                          <div
                            className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12`}
                          >
                            {this.state.ApplicationRole?.length
                              ? this.state.ApplicationRole?.map((r) => (
                                <div className="view-text">{r}</div>
                              ))
                              : "-"}
                          </div>
                        </>
                      )}
                      {isView &&
                        this.state.addeditUser?.historyLog?.length > 0 && (
                          <div>
                            <div className="pt-4">
                              <h6 className="text-20-bold">Audit log</h6>
                            </div>
                            <div className="audit-table-wrapper audit-scroll-css table-fixed-header">
                              <table className="px-3 audit-table">
                                <thead>
                                  <tr className="border-bottom">
                                    <th className="p-rem">Action</th>
                                    <th className="p-rem w-23">Action By</th>
                                    <th className="p-rem wid-45">Description</th>
                                    <th className="p-rem">Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.addeditUser?.historyLog.map(
                                    (x) => (
                                      <tr className="border-bottom">
                                        <td className="p-rem align-top">
                                          {x.action && x.action}
                                        </td>
                                        <td className="p-rem align-top">
                                          {x.actionBy && x.actionBy}
                                        </td>
                                        <td className="p-rem">{x.description && x.description}</td>
                                        <td className="p-rem align-top">
                                          {x.createdTime && moment
                                            .utc(x.createdTime)
                                            .local()
                                            .format("DD-MMM-YYYY hh:mm A")}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                      <div className="col-12 mt-4">
                        <button
                          className="d-none"
                          data-bs-dismiss={"offcanvas"}
                          id="closeModal"
                        >
                          {" "}
                          Save
                        </button>
                        {isAdd && (
                          <button
                            className="action-button px-3 py-2"
                            onClick={this.handleAddEdit}
                          >
                            <img className="img-top" src={SaveIcon} /> &nbsp;
                            Save
                          </button>
                        )}
                        {isEdit && (
                          <button
                            className="action-button px-3 py-2"
                            onClick={this.handleAddEdit}
                          >
                            <img className="img-top" src={SaveIcon} /> &nbsp;
                            Save changes
                          </button>
                        )}
                      </div>
                    </>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div
            id="largeModal"
            className="modal fade modal-top overflowy-hidden"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-all">
              <div className="modal-content px-4">
                <div className="row">
                  <div className="col-8 pr-0">
                    <div
                      className={`${"px-1 py-3 align-middle border-bottom-modal d-flex"}`}
                    >
                      {isImportFail && (
                        <>
                          <img src={FailedIcon} className="" />
                          <label className="modal-title text-20-bold pl-10">
                            Failed to Upload
                          </label>
                        </>
                      )}
                      {isImport && (
                        <>
                          <img src={importHead} className="" />
                          <label className="modal-title text-20-bold pl-20">
                            Import Users
                          </label>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-4 d-flex justify-content-end align-middle border-bottom-modal px-1 py-3">
                    <img
                      src={crossicon}
                      data-bs-dismiss="modal"
                      className={`cursor-pointer  w17px-h17px ${isMobile ? "pr-0" : ""
                        }`}
                    ></img>
                  </div>
                </div>
                <div
                  className={
                    isImportFail == true
                      ? "modal-delete mt-2"
                      : isImport == true
                        ? "mt-2"
                        : ""
                  }
                >
                  {isImport && (
                    <>
                      {" "}
                      <label>Choose a excel file</label>
                      <div className="d-flex mt-3 h-42px">
                        <div className="box-1 d-flex">
                          {this.state.importUsers?.length > 0 &&
                            this.state.importUsers[0]?.name != "" ? (
                            <div className="import-file p-2 text-10">
                              <img className="excel-img" src={excel} />
                              {this.state.importUsers[0]?.name}
                              <img
                                className="cursor-pointer cross-img"
                                onClick={() => this.handleRemoveImport()}
                                src={crossicon}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          className={`${isMobile600 ? "width50" : "width20"
                            } cursor-pointer`}
                        >
                          <div class="button-wrap box-2 cursor-pointer text-center pt-2 d-flex justify-content-center h-100">
                            <label
                              class="button"
                              className="cursor-pointer"
                              for="upload"
                            >
                              Choose a file
                            </label>
                            <input
                              id="upload"
                              className="cursor-pointer d-none w-90px"
                              type="file"
                              onChange={(e) => this.handleInputImportChange(e)}
                            />
                          </div>
                        </div>
                      </div>{" "}
                    </>
                  )}
                  {isImportFail && (
                    <>
                      <label className="text-14-normal fw-bold py-3">
                        Users failed to import
                      </label>
                      <div className="px-3">
                        <table width="100%" className="px-3">
                          <thead>
                            <tr className="border-bottom">
                              <th className="py-2 mr-5" width="15%">
                                S.No
                              </th>
                              <th className="py-2 pl-5 min-wid" width="25%">
                                Cell name
                              </th>
                              <th className="py-2" width="60%">
                                Description
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(this.state?.isImportFailList) &&
                              this.state?.isImportFailList?.length > 0 &&
                              this.state?.isImportFailList?.map((r, ind) => (
                                <tr className="border-bottom">
                                  <td className="py-2">{ind + 1}</td>
                                  <td className="py-2">{r?.cellName}</td>
                                  <td className="py-2">{r?.errorMessage}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
                <div className="py-3 text-center">
                  {isImport && (
                    <>
                      {" "}
                      <button
                        className="cancel-button text-12-bold px-4 py-2"
                        onClick={() => this.handleRemoveImport()}
                        id="cancellargeModal"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        className="success-button text-12-bold px-4 py-2 ml-10"
                        onClick={() => this.handleImportUsers()}
                      >
                        Upload
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <button
            className="d-none"
            id="openDeleteUsers"
            data-bs-toggle="modal"
            data-bs-target="#deleteUsersModal"
          ></button>

          <div
            id="deleteUsersModal"
            className="modal fade modal-top overflowy-hidden"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-all">
              <div className="modal-content px-4">
                <div className="row">
                  <div className="col-8 pr-0">
                    <div
                      className={`${"px-1 py-3 align-middle border-bottom-modal d-flex"}`}
                    >
                      <>
                        <img src={FailedIcon} className="" />
                        <label className="modal-title text-20-bold pl-10">
                          Failed to Delete
                        </label>
                      </>
                    </div>
                  </div>
                  <div className="col-4 d-flex justify-content-end align-middle border-bottom-modal px-1 py-3">
                    <img
                      src={crossicon}
                      data-bs-dismiss="modal"
                      className={`cursor-pointer  w17px-h17px ${isMobile ? "pr-0" : ""
                        }`}
                    ></img>
                  </div>
                </div>
                <div className={"mt-2 mb-4 pb-2 modal-delete"}>
                  <>
                    <label className="text-14-normal fw-bold py-3">
                      The following users are tagged as manager/supervisor
                    </label>
                    <div className="px-3">
                      <table width="100%" className="px-3">
                        <thead>
                          <tr className="border-bottom">
                            <th className="py-2" width="15%">
                              S.No
                            </th>
                            <th className="py-2" width="85%">
                              Email
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.deleteusersList?.length > 0 &&
                            this.state.deleteusersList?.map((r, ind) => (
                              <tr className="border-bottom">
                                <td className="py-2">{ind + 1}</td>
                                <td className="py-2">{r}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>

          <div
            id="deleteModal"
            className="modal fade modal-top"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-all">
              <div className="modal-content px-4">
                <div className="row">
                  <div className="col-12">
                    <div className="px-1 py-3 align-middle border-bottom-modal d-flex">
                      <img src={FailedIcon} className="" />
                      <label className="modal-title text-20-bold pl-10">
                        Warning
                      </label>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div>
                    <label className="text-16-bold pt-3">
                      Are you sure want to remove the users?
                    </label>
                  </div>
                  <div>
                    <label className="text-12-normal py-3">
                      All the information about the users will be lost.
                    </label>
                  </div>
                </div>
                <div className="py-3 text-center">
                  <button
                    className="cancel-button text-12-bold px-4 py-2"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    className="success-button text-12-bold px-4 py-2 ml-10"
                    data-bs-dismiss="modal"
                    onClick={this.DeleteYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            id="cancelModal"
            className="modal fade modal-top"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-all">
              <div className="modal-content px-4">
                <div className="row">
                  <div className="col-12">
                    <div className="px-1 py-3 align-middle border-bottom-modal">
                      <img src={FailedIcon} className="top-margin" />
                      <label className="modal-title text-20-bold pl-10">
                        Warning
                      </label>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div>
                    <label className="text-16-bold pt-3">
                      Are you sure you want to close?
                    </label>
                  </div>
                  <div>
                    <label className="text-12-normal py-3">
                      All the information you've entered for your user will be
                      lost.
                    </label>
                  </div>
                </div>
                <div className="py-3 text-center">
                  <button
                    className="cancel-button text-12-bold px-4 py-2"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    className="success-button text-12-bold px-4 py-2 ml-10"
                    data-bs-dismiss="modal"
                    onClick={this.CancelYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class={
            isAdd || isEdit || isView ? "offcanvas-backdrop fade show" : ""
          }
          onClick={() => this.handleBackdrop()}
        ></div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    sideMenu: state.commonReducer.sideMenu,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users));
